import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-innactive-user',
    templateUrl: './innactive-user.component.html',
    styleUrls: ['./innactive-user.component.scss']
})
export class InnactiveUserComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
